module.exports = __webpack_public_path__ + "static/linkedin-5bedcdc7c8ef9f3363c626b4c95bb048.png";